var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computedFn } from 'mobx-utils';
import { RegistryItem } from '../RegistryItem';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { addTraitDependency } from './TraitRegistryDependencies';
import { runtime } from '../../classes/runtime/Runtime';
export class TraitRegistryItem extends RegistryItem {
    parent;
    constructor(init = {}) {
        super(init);
        if (init.creates) {
            addTraitDependency(init.key, init.creates);
        }
    }
    type = 'trait';
    default;
    init;
    icon;
    ser;
    multiple;
    unifier;
    scale;
    aspectsTemplate;
    valueType;
    creates;
    isEnabled = ({ at }) => {
        return at.attachedCondition.isConditionTrue;
    };
    get defaultSerialized() {
        return { key: this.key, ...this.ser };
    }
    get isHidden() {
        if (this.hidden)
            return true;
        const entry = runtime.solidPackages.Edit.registryMetaInfo[`${this.type}s`] &&
            runtime.solidPackages.Edit.registryMetaInfo[`${this.type}s`][this.key];
        if (entry)
            return entry.hidden;
        return false;
    }
    get createTraitsOptimized() {
        // optimizes createTraits calls; avoids duplicate trait objects and therefore switching at
        return computedFn(this.createTraits);
    }
}
__decorate([
    memoize
], TraitRegistryItem.prototype, "createTraitsOptimized", null);
